import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _aggregation = {
    range: '_rangeAggregation',
    nested: '_nestedAggregation',
};
var _aggregationData = { results: '_aggregationResults' };
var _aggregationResults = {
    ranges: '_rangeResults',
    scalar: '_aggregationResultsScalarResult',
    groupedByValue: '_groupByValueResults',
    nested: '_nestedResults',
};
var _aggregationResultsScalarResult = { value: 'DOUBLE' };
var _countGiftCardsRequest = {};
var _countGiftCardsResponse = {};
var _createGiftCardRequest = { giftCard: '_giftCard' };
var _createGiftCardResponse = { giftCard: '_giftCard' };
var _cursorSearch = { aggregations: '_aggregation' };
var _decreaseBalanceRequest = { transaction: '_transaction' };
var _decreaseBalanceResponse = { transaction: '_transaction' };
var _disableGiftCardRequest = {};
var _disableGiftCardResponse = { giftCard: '_giftCard' };
var _getGiftCardRequest = {};
var _getGiftCardResponse = { giftCard: '_giftCard' };
var _giftCard = {
    expirationDate: 'google.protobuf.Timestamp',
    createdDate: 'google.protobuf.Timestamp',
    updatedDate: 'google.protobuf.Timestamp',
    disableDate: 'google.protobuf.Timestamp',
};
var _groupByValueResults = { results: '_nestedValueAggregationResult' };
var _increaseBalanceRequest = { transaction: '_transaction' };
var _increaseBalanceResponse = { transaction: '_transaction' };
var _nestedAggregation = { nestedAggregations: '_nestedAggregationItem' };
var _nestedAggregationItem = { range: '_rangeAggregation' };
var _nestedAggregationResults = {
    ranges: '_rangeResults',
    scalar: '_aggregationResultsScalarResult',
};
var _nestedResults = { results: '_results' };
var _nestedResultValue = { range: '_rangeResult', scalar: '_scalarResult' };
var _nestedValueAggregationResult = {
    nestedResults: '_nestedAggregationResults',
};
var _queryGiftCardsRequest = {};
var _queryGiftCardsResponse = { giftCards: '_giftCard' };
var _rangeAggregation = { buckets: '_rangeBucket' };
var _rangeAggregationResult = {
    from: 'google.protobuf.DoubleValue',
    to: 'google.protobuf.DoubleValue',
};
var _rangeBucket = {
    from: 'google.protobuf.DoubleValue',
    to: 'google.protobuf.DoubleValue',
};
var _rangeResult = {
    from: 'google.protobuf.DoubleValue',
    to: 'google.protobuf.DoubleValue',
};
var _rangeResults = { results: '_rangeAggregationResult' };
var _results = { results: 'Map#_nestedResultValue' };
var _scalarResult = { value: 'DOUBLE' };
var _searchGiftCardsRequest = { search: '_cursorSearch' };
var _searchGiftCardsResponse = {
    giftCards: '_giftCard',
    aggregationData: '_aggregationData',
};
var _transaction = { createdDate: 'google.protobuf.Timestamp' };
var _updateGiftCardRequest = {
    fieldMask: 'google.protobuf.FieldMask',
    giftCard: '_giftCard',
};
var _updateGiftCardResponse = { giftCard: '_giftCard' };
var _voidTransactionRequest = {};
var _voidTransactionResponse = { transaction: '_transaction' };
function resolveWixRiseV1GiftCardServiceUrl(opts) {
    var domainToMappings = {
        'bo._base_domain_': [
            {
                srcPath: '/_api/gift-cards-service',
                destPath: '',
            },
            {
                srcPath: '/v1/gift-cards',
                destPath: '/v1/rise/gift-cards',
            },
        ],
        'wixbo.ai': [
            {
                srcPath: '/_api/gift-cards-service',
                destPath: '',
            },
            {
                srcPath: '/v1/gift-cards',
                destPath: '/v1/rise/gift-cards',
            },
        ],
        'wix-bo.com': [
            {
                srcPath: '/_api/gift-cards-service',
                destPath: '',
            },
            {
                srcPath: '/v1/gift-cards',
                destPath: '/v1/rise/gift-cards',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/v1/rise/gift-cards',
                destPath: '/v1/rise/gift-cards',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/gift-cards-service',
                destPath: '/v1/rise',
            },
        ],
        'platform.rise.ai': [
            {
                srcPath: '/v1/rise/gift-cards',
                destPath: '/v1/rise/gift-cards',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/** Creates a new GiftCard */
export function createGiftCard(payload) {
    var _a = serializer(_createGiftCardRequest, { _giftCard: _giftCard }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createGiftCardResponse, {
        _giftCard: _giftCard,
    }).fromJSON;
    function __createGiftCard(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.rise.v1.gift_card',
            method: 'POST',
            methodFqn: 'wix.rise.v1.GiftCardService.CreateGiftCard',
            url: resolveWixRiseV1GiftCardServiceUrl({
                protoPath: '/v1/rise/gift-cards',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createGiftCard.fromReq = fromReq;
    __createGiftCard.__isAmbassador = true;
    return __createGiftCard;
}
/** Get a GiftCard by id */
export function getGiftCard(payload) {
    var _a = serializer(_getGiftCardRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getGiftCardResponse, { _giftCard: _giftCard }).fromJSON;
    function __getGiftCard(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.rise.v1.gift_card',
            method: 'GET',
            methodFqn: 'wix.rise.v1.GiftCardService.GetGiftCard',
            url: resolveWixRiseV1GiftCardServiceUrl({
                protoPath: '/v1/rise/gift-cards/{giftCardId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getGiftCard.fromReq = fromReq;
    __getGiftCard.__isAmbassador = true;
    return __getGiftCard;
}
/**
 * Update a GiftCard, supports partial update
 * Pass the latest `revision` for a successful update
 */
export function updateGiftCard(payload) {
    var _a = serializer(_updateGiftCardRequest, { _giftCard: _giftCard }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateGiftCardResponse, {
        _giftCard: _giftCard,
    }).fromJSON;
    function __updateGiftCard(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.rise.v1.gift_card',
            method: 'PATCH',
            methodFqn: 'wix.rise.v1.GiftCardService.UpdateGiftCard',
            url: resolveWixRiseV1GiftCardServiceUrl({
                protoPath: '/v1/rise/gift-cards/{giftCardId}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateGiftCard.fromReq = fromReq;
    __updateGiftCard.__isAmbassador = true;
    return __updateGiftCard;
}
/** Disable a GiftCard */
export function disableGiftCard(payload) {
    var _a = serializer(_disableGiftCardRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_disableGiftCardResponse, {
        _giftCard: _giftCard,
    }).fromJSON;
    function __disableGiftCard(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.rise.v1.gift_card',
            method: 'POST',
            methodFqn: 'wix.rise.v1.GiftCardService.DisableGiftCard',
            url: resolveWixRiseV1GiftCardServiceUrl({
                protoPath: '/v1/rise/gift-cards/{giftCardId}/disable',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __disableGiftCard.fromReq = fromReq;
    __disableGiftCard.__isAmbassador = true;
    return __disableGiftCard;
}
/** Adds to the GiftCard balance and creates a balance Transaction. */
export function increaseBalance(payload) {
    var _a = serializer(_increaseBalanceRequest, { _transaction: _transaction }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_increaseBalanceResponse, {
        _transaction: _transaction,
    }).fromJSON;
    function __increaseBalance(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.rise.v1.gift_card',
            method: 'POST',
            methodFqn: 'wix.rise.v1.GiftCardService.IncreaseBalance',
            url: resolveWixRiseV1GiftCardServiceUrl({
                protoPath: '/v1/rise/gift-cards/{transaction.giftCardId}/increase',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __increaseBalance.fromReq = fromReq;
    __increaseBalance.__isAmbassador = true;
    return __increaseBalance;
}
/** Subtracts from the GiftCard balance and creates a balance Transaction. */
export function decreaseBalance(payload) {
    var _a = serializer(_decreaseBalanceRequest, { _transaction: _transaction }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_decreaseBalanceResponse, {
        _transaction: _transaction,
    }).fromJSON;
    function __decreaseBalance(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.rise.v1.gift_card',
            method: 'POST',
            methodFqn: 'wix.rise.v1.GiftCardService.DecreaseBalance',
            url: resolveWixRiseV1GiftCardServiceUrl({
                protoPath: '/v1/rise/gift-cards/{transaction.giftCardId}/decrease',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __decreaseBalance.fromReq = fromReq;
    __decreaseBalance.__isAmbassador = true;
    return __decreaseBalance;
}
export function voidTransaction(payload) {
    var _a = serializer(_voidTransactionRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_voidTransactionResponse, {
        _transaction: _transaction,
    }).fromJSON;
    function __voidTransaction(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.rise.v1.gift_card',
            method: 'POST',
            methodFqn: 'wix.rise.v1.GiftCardService.VoidTransaction',
            url: resolveWixRiseV1GiftCardServiceUrl({
                protoPath: '/v1/rise/gift-cards/transaction/{transactionId}/void',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __voidTransaction.fromReq = fromReq;
    __voidTransaction.__isAmbassador = true;
    return __voidTransaction;
}
/** Query GiftCards using [WQL - Wix Query Language](https://dev.wix.com/api/rest/getting-started/api-query-language) */
export function queryGiftCards(payload) {
    var _a = serializer(_queryGiftCardsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryGiftCardsResponse, {
        _giftCard: _giftCard,
    }).fromJSON;
    function __queryGiftCards(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.rise.v1.gift_card',
            method: 'POST',
            methodFqn: 'wix.rise.v1.GiftCardService.QueryGiftCards',
            url: resolveWixRiseV1GiftCardServiceUrl({
                protoPath: '/v1/rise/gift-cards/query',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __queryGiftCards.fromReq = fromReq;
    __queryGiftCards.__isAmbassador = true;
    return __queryGiftCards;
}
export function countGiftCards(payload) {
    var _a = serializer(_countGiftCardsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_countGiftCardsResponse, {}).fromJSON;
    function __countGiftCards(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.rise.v1.gift_card',
            method: 'POST',
            methodFqn: 'wix.rise.v1.GiftCardService.CountGiftCards',
            url: resolveWixRiseV1GiftCardServiceUrl({
                protoPath: '/v1/rise/gift-cards/count',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __countGiftCards.fromReq = fromReq;
    __countGiftCards.__isAmbassador = true;
    return __countGiftCards;
}
export function searchGiftCards(payload) {
    var _a = serializer(_searchGiftCardsRequest, {
        _aggregation: _aggregation,
        _cursorSearch: _cursorSearch,
        _nestedAggregation: _nestedAggregation,
        _nestedAggregationItem: _nestedAggregationItem,
        _rangeAggregation: _rangeAggregation,
        _rangeBucket: _rangeBucket,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_searchGiftCardsResponse, {
        _aggregationData: _aggregationData,
        _aggregationResults: _aggregationResults,
        _aggregationResultsScalarResult: _aggregationResultsScalarResult,
        _giftCard: _giftCard,
        _groupByValueResults: _groupByValueResults,
        _nestedAggregationResults: _nestedAggregationResults,
        _nestedResultValue: _nestedResultValue,
        _nestedResults: _nestedResults,
        _nestedValueAggregationResult: _nestedValueAggregationResult,
        _rangeAggregationResult: _rangeAggregationResult,
        _rangeResult: _rangeResult,
        _rangeResults: _rangeResults,
        _results: _results,
        _scalarResult: _scalarResult,
    }).fromJSON;
    function __searchGiftCards(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.rise.v1.gift_card',
            method: 'POST',
            methodFqn: 'wix.rise.v1.GiftCardService.SearchGiftCards',
            url: resolveWixRiseV1GiftCardServiceUrl({
                protoPath: '/v1/rise/gift-cards/search',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __searchGiftCards.fromReq = fromReq;
    __searchGiftCards.__isAmbassador = true;
    return __searchGiftCards;
}
//# sourceMappingURL=http.impl.js.map